import React from 'react'
import { withIcon } from '../../withIcon'

function PlaylistIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M15.459 9.77051C16.0112 9.77056 16.459 10.2183 16.459 10.7705V16.7969C16.4588 17.349 16.0111 17.7968 15.459 17.7969H4.97363C4.42145 17.7969 3.9738 17.349 3.97363 16.7969V10.7705C3.97363 10.2182 4.42135 9.77051 4.97363 9.77051H15.459ZM17.2422 7.98633C17.3066 7.98633 17.3696 7.99226 17.4307 8.00391C17.4679 8.01099 17.5044 8.02017 17.54 8.03125C17.6025 8.05073 17.6622 8.07667 17.7188 8.10742C18.0305 8.27665 18.242 8.60668 18.2422 8.98633V15.0127C18.2422 15.5284 17.8519 15.9528 17.3506 16.0068V9.32422C17.3505 9.07805 17.1505 8.87891 16.9043 8.87891H5.7627C5.8165 8.37742 6.24116 7.98653 6.75684 7.98633H17.2422ZM19.0264 6.20312C19.5785 6.20327 20.0264 6.65093 20.0264 7.20312V13.2295C20.0263 13.745 19.6359 14.1695 19.1348 14.2236V7.54102C19.1348 7.29478 18.9347 7.09477 18.6885 7.09473H7.54688C7.60091 6.59343 8.02536 6.20312 8.54102 6.20312H19.0264Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlaylistIcon)
